<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener("DOMContentLoaded", function () {
  const tooltip = document.createElement("div");
  tooltip.className = "tooltip-tt";
  document.body.appendChild(tooltip);

  document.querySelectorAll("[data-tooltip]").forEach(elem => {
    elem.addEventListener("mouseenter", function () {
      tooltip.textContent = this.dataset.tooltip;

      // Get the dimensions of the hovered element
      const rect = this.getBoundingClientRect();

      // Position the tooltip
      tooltip.style.left = rect.left + rect.width / 2 + window.scrollX - tooltip.offsetWidth / 2 + "px";
      tooltip.style.top = rect.bottom + 10 + window.scrollY + "px";

      // Show tooltip
      tooltip.style.display = "block";
      setTimeout(() => tooltip.style.opacity = "1", 0);
    });

    elem.addEventListener("mouseleave", function () {
      tooltip.style.opacity = "0";
      setTimeout(() => tooltip.style.display = "none", 200);
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const tooltipss = document.createElement("div");
  tooltipss.className = "tooltip-ss";
  document.body.appendChild(tooltipss);

  document.querySelectorAll("[data-tooltipss]").forEach(elem => {
    elem.addEventListener("mouseenter", function () {
      tooltipss.textContent = this.dataset.tooltipss;

      // Get the dimensions of the hovered element
      const rect = this.getBoundingClientRect();

      // Position the tooltip
      tooltipss.style.left = rect.left + rect.width / 2 + window.scrollX - tooltipss.offsetWidth / 2 + "px";
      tooltipss.style.top = rect.bottom + 10 + window.scrollY + "px";

      // Show tooltip
      tooltipss.style.display = "block";
      setTimeout(() => tooltipss.style.opacity = "1", 0);
    });

    elem.addEventListener("mouseleave", function () {
      tooltipss.style.opacity = "0";
      setTimeout(() => tooltip.style.display = "none", 200);
    });
  });
});

